import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Blocking overlay shown on top of protected pages when the signed-in account
 * lacks the Brownlow Genius entitlement. The sidenav stays visible above it
 * (only the account/logout avatar remains interactive); everything else is
 * covered by the backdrop. Deliberately not dismissible — it's an access
 * wall, not a notice.
 */
const ComingSoonModal = () => {
  const { user } = useAuth();

  // The page behind is view-only while locked, so freeze its scroll.
  useEffect(() => {
    const previous = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previous;
    };
  }, []);

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="coming-soon-title"
      className="fixed inset-0 z-[9990] flex items-center justify-center px-4 py-10 md:pl-[calc(72px+1rem)]"
    >
      <div className="absolute inset-0 bg-[#020817]/85 backdrop-blur-md" />

      <div className="relative w-full max-w-md rounded-2xl border border-slate-700/50 bg-gradient-to-b from-slate-900/90 to-slate-900/70 p-6 md:p-7 shadow-2xl shadow-black/60 animate-slide-up">
        <div className="flex flex-col items-center text-center">
          <img src="/favicon.svg" alt="" aria-hidden="true" className="h-10 w-auto object-contain" />

          <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-amber-400/30 bg-amber-400/10 px-3 py-1">
            <span className="text-[10px] font-mono uppercase tracking-[0.16em] text-amber-300">
              Coming soon
            </span>
          </div>

          <h1 id="coming-soon-title" className="mt-4 text-lg font-bold tracking-tight text-white">
            Brownlow Genius is currently not available
          </h1>

          <p className="mt-2.5 text-[13px] leading-relaxed text-slate-400">
            Your account doesn&apos;t have access to Brownlow Genius yet. We&apos;re putting the
            finishing touches on it — check back soon.
          </p>

          {user?.email && (
            <p className="mt-4 text-[11px] text-slate-600">
              Signed in as <span className="text-slate-500">{user.email}</span>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default ComingSoonModal;
